export function SearchInput() {
  return (
    <div
      className="flex items-center gap-2 bg-white border border-border-default rounded-md px-3 py-1.5 w-[260px]"
      title="Search — coming soon"
    >
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <circle cx="7" cy="7" r="4.5" stroke="#8B948F" strokeWidth="1.4" />
        <path d="M11 11l3 3" stroke="#8B948F" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
      <input disabled placeholder="Search"
        className="flex-1 bg-transparent outline-none text-[13px] placeholder:text-text-faint" />
    </div>
  );
}
